import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';

import { MainService } from '../delavci/main.service';
import { AppConfigServiceService } from '../app-config-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {
//Guard, ki v route spusti le delavce
  constructor(private mainService: MainService, private router: Router, private appCongifService: AppConfigServiceService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.mainService.currentUserValue) {
      if(this.mainService.currentUserValue.workerId == null || this.mainService.currentUserValue.userId == null ||
        this.mainService.currentUserValue.sessionUser == null) {
       return false;
     } else {
       return true;
     }
    }
    if(this.appCongifService.api != 'https://wwworig.bilumina.com/develApi/rest/') {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/login-partner']);
    }


    return false;
  }
}
